import { FormattedDebts } from "./transform";

/**
 * Une listas de passagens por `id`, evitando duplicatas ao acumular
 * resultados parciais do polling (flSituacao === 1).
 * Itens com o mesmo id são sobrescritos pelos de `incoming`.
 */
export function mergeFormattedDebts(
  existing: FormattedDebts[],
  incoming: FormattedDebts[],
): FormattedDebts[] {
  const byId = new Map<string, FormattedDebts>();

  for (const debt of existing) {
    if (debt?.id) byId.set(debt.id, debt);
  }

  for (const debt of incoming) {
    if (debt?.id) byId.set(debt.id, debt);
  }

  return Array.from(byId.values());
}
